import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import { FaThumbsUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import Alert from '../../components/Alert';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelCliente() {
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [clientes, setClientes] = useState([]);
    const [abaAtiva, setAbaAtiva] = useState('ativo');
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = (id) => setSelectedIds(prev => {
        const n = new Set(prev);
        n.has(id) ? n.delete(id) : n.add(id);
        return n;
    });

    const toggleAll = () => {
        if (paginados.length > 0 && selectedIds.size === paginados.length) {
            setSelectedIds(new Set());
        } else {
            setSelectedIds(new Set(paginados.map(r => r.id)));
        }
    };

    // Estado dos dados que a ND imprime (cadastro do cliente, aba Banco / Cobrança).
    // A conta é o que faz sair o rodapé bancário; o prazo é o que faz sair a data de
    // vencimento. Ter só um dos dois já gera documento incompleto — por isso "Parcial"
    // em vez de um sim/não, senão o operador acha que está resolvido e não está.
    const tagCobranca = (row) => {
        const temConta = !!row.conta_recebimento;
        const temPrazo = row.prazopagamento !== null && row.prazopagamento !== undefined && row.prazopagamento !== '';

        if (temConta && temPrazo) {
            return <span className="fin-pp__minitag is-ok" title="Conta de recebimento e prazo cadastrados">Completa</span>;
        }
        if (temConta || temPrazo) {
            return (
                <span className="fin-pp__minitag is-warn" title={temConta ? 'Falta o prazo de pagamento' : 'Falta a conta de recebimento'}>
                    {temConta ? 'Sem prazo' : 'Sem conta'}
                </span>
            );
        }
        return <span className="fin-pp__minitag" title="ND sai sem rodapé bancário e sem vencimento">Não configurada</span>;
    };

    const total = clientes.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = clientes.slice((page - 1) * pageSize, page * pageSize);
    const selectedArr = [...selectedIds];

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: { ...filtro, ...{ tipoCadastro: "cliente", situacaoRegistro: abaAtiva } },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setClientes(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
                //console.log(err)
            });
    };

    const excluir = (rowId) => {
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/participante/' + rowId,
                        token: token
                    })
                        .then(function (response) {
                            setSelectedIds(new Set());
                            buscar();
                        })
                        .catch(function (error) {
                            //alert(error)
                        });
                }
            }
        });
    };

    useEffect(() => {
        document.querySelector("#nome") && document.querySelector("#nome").focus();
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        [abaAtiva]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Clientes</h1></div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroCliente" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Novo Cliente
                        </Link>
                    </div>
                </div>

                <form className="fin-pp__card fin-pp__search" style={{ marginBottom: 16, padding: '12px 16px' }} onSubmit={e => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            id="nome"
                            className="fin-pp__input"
                            type="text"
                            placeholder="Buscar pelo nome do cliente"
                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                        {buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                <div className="fin-pp__tabs mb-3">
                    {[
                        { key: 'ativo', label: 'Ativos' },
                        { key: 'inativo', label: 'Inativos' },
                    ].map((item) => (
                        <button
                            key={item.key}
                            type="button"
                            className={'fin-pp__tab' + (abaAtiva === item.key ? ' is-active' : '')}
                            onClick={() => { setAbaAtiva(item.key); setPage(1); setSelectedIds(new Set()); }}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>

                {selectedArr.length === 1 && ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil) && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                            onClick={() => excluir(selectedArr[0])}
                        >
                            <ImCancelCircle size={14} /> Excluir
                        </button>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>
                                        <input
                                            type="checkbox"
                                            checked={paginados.length > 0 && selectedIds.size === paginados.length}
                                            onChange={toggleAll}
                                        />
                                    </th>
                                    <th style={{ width: 60 }}></th>
                                    <th>Situação</th>
                                    <th>Código</th>
                                    <th>Nome</th>
                                    <th>Município</th>
                                    <th>CNPJ/CPF</th>
                                    <th>Nome Fantasia</th>
                                    <th>Cobrança</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando
                                    ? <tr><td colSpan={9} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0
                                        ? <tr><td colSpan={9} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.has(row.id)}
                                                        onChange={() => toggleSelect(row.id)}
                                                    />
                                                </td>
                                                <td>
                                                    <Link to={"/cadastroCliente/" + row.id} className="fin-pp__rowbtn">
                                                        <FaPen size={14} />
                                                    </Link>
                                                </td>
                                                <td>
                                                    <span className={`fin-pp__pill ${row.situacaoRegistro === 'ativo' ? 'is-ok' : 'is-muted'}`}>
                                                        {row.situacaoRegistro}
                                                    </span>
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.codigo ?? ""}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ""}</td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.enderecomunicipio ? row.enderecomunicipio.nome + '-' + row.enderecomunicipio.uf : ""}
                                                </td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.cnpj !== '' ? <div>{row.cnpj}</div> : null}
                                                    {row.cpf !== '' ? <div>{row.cpf}</div> : null}
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.nomefantasia ?? ""}</td>
                                                <td>{tagCobranca(row)}</td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pageSize}
                                onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
                            >
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
